<div fxLayout="column" fxFlexFill *ngIf="clientMerchants$ && !loader">

  <div *ngIf="clientMerchants$.length > 0" class="scrolled layout-padd" fxLayout="column" fxFlex>

    <div class="mb-4">
      <div class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">{{"client.menu.merchants" | translate | uppercase}}</div>
      <div class="text-sm text-gray-800 font-semibold">{{"dashboardComponent.chooseMerchant"|translate}}</div>
    </div>

    <div class="relative w-full max-w-sm mb-8">
      <input
        type="text"
        placeholder="Recherche"
        [ngClass]="cssService.formInputClass"
        [(ngModel)]="searchMerchants"
        *ngIf="clientMerchants$ && clientMerchants$.length > 0"
      />
      <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
        <mat-icon>search</mat-icon>
      </span>
    </div>

    <div fxFlex>

      <div class="grid gap-4 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">

        <div *ngFor="let merchant of clientMerchants$ |searchFilter:clientMerchants$:searchMerchants "
             angulartics2On="click" angularticsAction="goMerchantOptions"
             angularticsCategory="clientMerchants"
             class="cursor-pointer flex flex-col"
             (click)="goUserOptions(merchant)"
             [ngClass]="cssService.cardMerchantClass">

          <img src="{{ ( merchant.points_of_sale[0].banner ? (merchant.points_of_sale[0].banner | prodSizeFilter:'512') :
                    merchant.points_of_sale[0].banner_original ) }}" alt="Card Image" class="w-full h-20 object-cover">

          <div class="flex-1 flex flex-row p-4 gap-4 items-center">

            <div class="flex-1 flex flex-col">
              <div class=" flex flex-col gap-1">
                <div
                  class="text-lg font-semibold text-gray-800 fontPoppins">{{merchant.denomination | uppercase | descFilter: 30}}</div>
                <p
                  class="text-xs text-gray-600 text-orange-400">{{ merchant.test_account == 1 ? ("dashboardComponent.demoAccount"|translate) :
                  ""}}</p>
              </div>
            </div>

            <!-- Flèche en bas à droite -->
            <div>
              <div class="bg-indigo-50 text-gray-800 rounded-full p-2 hover:bg-indigo-100 transition">
                <i class="fas fa-arrow-right"></i>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

  <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill
       *ngIf="clientMerchants$.length == 0">
    <span class="mat-title"> {{"dashboardComponent.nomerchant"|translate}}</span>
  </div>

</div>

<!--
<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'merchantComponent.getmerchant'|translate">
</app-popup-loader>-->
